import { render, staticRenderFns } from "./ExtractionAffiliation.vue?vue&type=template&id=1abbff88"
import script from "./ExtractionAffiliation.vue?vue&type=script&lang=js"
export * from "./ExtractionAffiliation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports